import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { PaymentService } from 'src/app/shared/services/payment.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SingleResultApiResponse, ApiResponse } from 'src/app/shared/models/api-response.model';
import { ApplicationPayment, Voucher, PaymentUpdateModel} from '../models/application-payment';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { ApplicationDetail } from '../models/application-detail';
import { IApplicationStep } from '../models/application-step.interface';
import { Store } from '@ngrx/store';
import { Action_ApplicationSectionSaved } from '../state/actions';
import { Title } from '@angular/platform-browser';
import { Tab_Title } from 'src/app/shared/models/lookup-data.model';


@Component({
  selector: 'online-app-application-payment',
  templateUrl: './application-payment.component.html',
  styleUrls: ['./application-payment.component.scss'],
  host: {
    class: 'application-section-component'
  },
})
export class ApplicationPaymentComponent implements OnInit {

  applicationPaymentFormGroup: FormGroup;
  applicationId: number;
  applicationPaymentDetails: ApplicationPayment;
  voucherDetails: Voucher;
  voucherError = '';
  isVoucherSubmitted: boolean = false;
  discountAmount = 0;
  totalAmountAfterDiscount: number;
  isPaymentCompleted: boolean = false;
  applicationDetail: ApplicationDetail;
  applicationSteps: IApplicationStep[];
  isPaymentReady: boolean;
  isAgeValidForProgramStartDate: boolean;
  isTermSelectionValidForToday: boolean;
  paymentStatus: string;
  paymentDetail: any;

  paymentApplicationTypeId = 3;

  errorKeyFormFieldMapping = [
    { apiErrorKeyName: 'voucherNumber', formFieldName: 'voucherNumber', apiValidationErrorMsg: null },
  ];

  sections = [
    {name: 'StudentDetails', visiblilityStatus: false, completionStatus: false},
    {name: 'ParentGuardianDetails', visiblilityStatus: false, completionStatus: false},
    {name: 'VisaAndOhscDetails', visiblilityStatus: false, completionStatus: false},
    {name: 'SchoolProgramAndPlacement', visiblilityStatus: false, completionStatus: false},
    {name: 'AccommodationAndWelfare', visiblilityStatus: false, completionStatus: false},
    {name: 'EnglishProficiency', visiblilityStatus: false, completionStatus: false},
    {name: 'SpecialCircumstances', visiblilityStatus: false, completionStatus: false},
    {name: 'DefaultCorrespondent', visiblilityStatus: false, completionStatus: false },
    {name: 'SupportingDocuments', visiblilityStatus: false, completionStatus: false },    
    {name: 'MakePayment', visiblilityStatus: false, completionStatus: false },
  ];


  constructor(private route: ActivatedRoute,
              private router: Router,
              private applicationService: ApplicationService,
              private paymentService: PaymentService,
              private store: Store<any>,
              private fb: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private titleService: Title
              ) {
                this.activatedRoute.parent.params.subscribe( params => {
                  this.applicationId = +params['id'];
                });

                this.applicationPaymentDetails = new ApplicationPayment();
                this.applicationSteps = this.applicationService.getApplicationSteps();

               }



  ngOnInit() { 
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_Payment_Title);
    }else{
      this.titleService.setTitle(Tab_Title.Payment_Title);
    }
    this.paymentStatus = this.route.snapshot.paramMap.get("paymentStatus");
    // console.log(this.paymentStatus);

    this.applicationPaymentFormGroup = this.fb.group({
      voucherNumber: ''
    });

    this.updatePaymentFromWestpac();

    this.applicationService.getApplicationSections(this.applicationId)
      .subscribe((response: ApiResponse) => {
        this.updateSectionCompletionStatus(response.Result);

        // if all sections except for last payment section is 'Complete', then good to go
        this.isPaymentReady = !this.sections.some(section => section.completionStatus === false && section.name !== 'MakePayment');
        
        this.isPaymentCompleted = this.isPaymentCompleted ||
                this.sections.some(section => section.completionStatus === true && section.name === 'MakePayment');


        if(!this.isPaymentCompleted) {
          this.applicationService.areAgeAndProgramSelectionStillValid(this.applicationId)
            .subscribe((response: SingleResultApiResponse) => {
              this.isAgeValidForProgramStartDate = response.Result.IsAgeValidForProgramStartDate;
              this.isTermSelectionValidForToday = response.Result.IsTermSelectionValidForToday;

              this.isPaymentReady = this.isPaymentReady && this.isAgeValidForProgramStartDate && this.isTermSelectionValidForToday;

              if ( this.isPaymentReady) {
                this.applicationService.getApplicationPaymentDetails(this.applicationId)
                  .subscribe( (pResponse: SingleResultApiResponse) => {
                  if (pResponse.Result) {
                    this.updateApplicationPaymentDetails(pResponse.Result);
                  }
                  }, err => {
                    console.error(err);
                  });
    
                this.applicationService.getApplicationDetails(this.applicationId)
                  .subscribe( (aResponse: SingleResultApiResponse) => {
                    if (aResponse.Result) {
                      this.applicationDetail = aResponse.Result;
                    }    
                  }, (err: ErrorResponse) => {
                    console.log(err);
                  });
              }

            }, err => {
              console.log(err);
            });
        } else {
          this.isAgeValidForProgramStartDate = true;
          this.isTermSelectionValidForToday = true;
          this.applicationService.getApplicationPaymentDetails(this.applicationId)
            .subscribe( (pResponse: SingleResultApiResponse) => {
            if (pResponse.Result) {
              this.paymentDetail = pResponse.Result;
            }
            }, err => {
              console.error(err);
            });
        }

      }, err => {
          console.error(err);
      });

  }



  updateSectionCompletionStatus(applicationSections: ApplicationSection[]) {

    // this.sections
    for (const section of applicationSections  ) {
      const appSection = this.sections.find(appStep => appStep.name === section.Type);

      if(appSection){
        appSection.completionStatus = section.Status === 'Complete';
      }
    }

  }


  makePayment() {
     // tslint:disable-next-line:max-line-length
     // window.location.href = 'http://externalservice.det.nsw.edu.au/payment/MakePaymentAsync?applicationId=1&paymentDescription=aaa&paymentAmount=123&invoiceNumber=INV009965';

    let voucherNumber = this.applicationPaymentFormGroup.get('voucherNumber').value;

     this.applicationService.makeApplicationPaymentDetails(this.applicationId, voucherNumber)

          .subscribe( (response: SingleResultApiResponse) => {

            const { IsFullDiscount, TotalAmountAfterDiscount, InvoiceNumber } = response.Result;
            const paymentDescription = 'OnlineApplicationPayment';

            if (IsFullDiscount) {
              this.isPaymentCompleted = true;

              // Auto-refresh left-side menu res => f2()
              // this.sections.filter(x => x.name == "MakePayment")[0].completionStatus = true;
              this.dispatchSectionSaveAction();

              this.paymentDetail = {
                ApplicationNumber: this.applicationPaymentDetails.ApplicationNumber,
                Currency: "AUD",
                TotalAmountAfterDiscount: "0.00"};


              //Immediately call external web api to trigger data copy!
              this.applicationService.processDataCopyAsync(this.applicationId).subscribe((response: SingleResultApiResponse) => { });     

            } else {
              // http://isponlineapi.det.nsw.edu.au/api/payment/getexternalpaymentserviceurl?paymentApplicationTypeId=3&onelineApplicationId=1122&paymentAmount=280&invoiceNumber=A12948
                this.paymentService.getpaymentgatewayurl(this.paymentApplicationTypeId, this.applicationId, TotalAmountAfterDiscount, InvoiceNumber)
                .subscribe((result: any) => {
                  console.log('Payment external getway URL is: ' + result.Result);
                  if(!result || !result.Result){
                    console.log('server error');
                    this.router.navigate(['/server-error']);
                  }else{
                    window.location.href = result.Result;

                  }

                  
                },
                err => {
                  console.log(err);
                  this.router.navigate(['/server-error']);
                });

              //let observableBatch = [];
              //observableBatch.push(this.paymentService.getcohortpaymentgatewayurl());
              //observableBatch.push(this.paymentService.getcohortpaymentparameterbase(this.applicationId));

              //let observable: Observable<any> = forkJoin(observableBatch);

              //observable.subscribe(
              //  data => {
              //    //console.log("cohort api url issss:", data[0]);
              //    //console.log("cohort paramter re-write from cohort issss", data[1]);
              //    //CohortPaymentParameter
              //  }, (errorResponse: ErrorResponse) => {}); 
            } 

          }, (errorResponse: ErrorResponse) => {

            const { errors } = errorResponse;
            for (const error of errors) {
              this.setApiValidationError(error.Key, error.Value);
            }
            this.applicationPaymentFormGroup.updateValueAndValidity();

          });
  }


  validateVoucher() {

    this.isVoucherSubmitted  = true;
    const voucherNumber = this.applicationPaymentFormGroup.get('voucherNumber').value;

    this.applicationService.validateVoucher(this.applicationId, voucherNumber)
        .subscribe( (response: SingleResultApiResponse) => {

          if (response.Result) {
            //console.log('successfully validated the voucher');
            this.voucherDetails = response.Result;
            this.applicationPaymentDetails.DiscountAmount = this.voucherDetails.VoucherDiscountAmount;
            this.applicationPaymentDetails.TotalAmountAfterDiscount = this.voucherDetails.TotalAmountAfterDiscount;
            //console.log(response.Result);
          }

        }, (errorResponse: ErrorResponse) => {

          const { errors } = errorResponse;
          console.log(errorResponse);
          
          for (const error of errors) {
            if(!voucherNumber){
              error.Key = "voucherNumber";
            }
            this.setApiValidationError(error.Key, error.Value);
          }
          this.applicationPaymentFormGroup.updateValueAndValidity();
        });

  }


  updateApplicationPaymentDetails(result: any) {

    //console.log('result');
    //console.log(result);

    this.applicationPaymentDetails.ApplicationNumber = result.ApplicationNumber;
    this.applicationPaymentDetails.InvoiceNumber = result.InvoiceNumber;
    this.applicationPaymentDetails.ApplicationFee = result.ApplicationFee;
    this.applicationPaymentDetails.Currency = result.Currency;
    this.applicationPaymentDetails.DiscountAmount = 0;
    this.applicationPaymentDetails.TotalAmountAfterDiscount = result.ApplicationFee;

    //console.log('applicationPaymentDetails');
    //console.log(this.applicationPaymentDetails);
  }

  voucherNumberChange(){
    const voucherNumber = this.applicationPaymentFormGroup.get('voucherNumber').value;
    console.log(voucherNumber)
    if(!voucherNumber){
      this.applicationPaymentDetails.DiscountAmount = 0;
      this.applicationPaymentDetails.TotalAmountAfterDiscount = this.applicationPaymentDetails.ApplicationFee;
    }
  }


  updatePaymentFromWestpac() {

    this.activatedRoute.queryParams.subscribe(params => {
      const receiptNumber = params['receiptNumber']; // receiptNumber
      // if (receiptNumber) {
      //  alert(receiptNumber);
      // }

      const responseCode = params['responseCode'];
      // if (responseCode) {
      //  alert(responseCode);
      // }

      if (receiptNumber && responseCode) {
        this.isPaymentCompleted = true;


        // call API to update Payment record in OnlineApplication
        const paymentUpdateModel: PaymentUpdateModel = {
          ResponseCode: responseCode,
          ReceiptNumber: receiptNumber,
          ApplicationId: this.applicationId,
          PaymentStatus: 'Complete'
        };

        this.paymentService.updatepaymentrecord(paymentUpdateModel).subscribe(
          (result: any) => {

            // Auto-refresh left-side menu
            // this.sections.filter(x => x.name == "MakePayment")[0].completionStatus = true;
            this.dispatchSectionSaveAction();
          }
        );
      }
    });
  }



  setApiValidationError(apiErrorKeyName: string, apiErrorMsg): void {
    const errorField = this.errorKeyFormFieldMapping.find( errorKeyFormField => errorKeyFormField.apiErrorKeyName === apiErrorKeyName);
    if (errorField) {
      const { formFieldName }  = errorField;
      this.applicationPaymentFormGroup.get(formFieldName).setErrors({apiValidationError : true});
      errorField.apiValidationErrorMsg = apiErrorMsg;
    }

  }

  getApiValidationErrorMsg(formFieldName: string): string {
    const errorField = this.errorKeyFormFieldMapping.find( errorKeyFormField => errorKeyFormField.formFieldName === formFieldName);
    return errorField.apiValidationErrorMsg ? errorField.apiValidationErrorMsg : '';
  }


  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }


  previous() {
    const userType = localStorage.getItem('userType');

    if (userType === 'agent') {
      this.router.navigate(['/applications', this.applicationId, 'edit', 'agent-details']);
    } else {
      this.router.navigate(['/applications', this.applicationId, 'edit', 'summary']);
    }
  }

}
